import request from '@/utils/request'

export function validateMember(query) {
  return request({
    url: '/order/exchange/validate',
    method: 'get',
    params: query
  })
}

export function fetchGoods(query) {
  return request({
    url: '/order/exchange/goods',
    method: 'get',
    params: query
  })
}

export function createOrder(data) {
  return request({
    url: '/order/exchange/create',
    method: 'post',
    data
  })
}
